export const getClickedColId = (evt) => {
  const nativeEvent = evt?.event || evt?.e || evt?.nativeEvent;
  const target = nativeEvent?.target;
  if (target?.closest) {
    const cellEl = target.closest('.ag-cell');
    return cellEl?.getAttribute?.('col-id') || null;
  }
  return null;
};
